<template>
  <modal v-if="visible">
    <template slot="modal-header">
      <h2 class="mt-3">Associated Campaigns for {{ audience.name }}, {{ audience.scopeDisplay }}, {{ audience.client.title }}</h2>
    </template>
    <template slot="modal-body">
      <div class="px-3">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: false,
          }"
          :isLoading.sync="api['GET-CAMPAIGNS'].loading"
          mode="remote"
          @on-page-change="handlePageChanged"
          :pagination-options="paginationOptions"
          :totalRows="totalRows"
        ></vue-good-table>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="mb-3">
        <app-primary-button
          label="Close"
          @click.native="closeModal"
        ></app-primary-button>
      </div>
    </template>
  </modal>
</template>
<script>
import {VueGoodTable} from 'vue-good-table';
import AppPrimaryButton from '../../AppComponents/Forms/AppPrimaryButton.vue';
import Modal from '../../../helpers/Modal.vue';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import ApiCallMixin from '../../../mixins/ApiCallMixin';

export default {
  props: ['visible', 'audience'],
  mixins: [ApiCallMixin],
  components: {
    VueGoodTable,
    AppPrimaryButton,
    Modal,
  },
  data() {
    return {
      rows: [],
      currentPage: 1,
      totalRows: 0,
    };
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    async getCampaigns(payload = {}) {
      const response = await AudienceServiceV2.getAudienceCampaigns(
        this.audience.id,
        payload
      );

      if (response && response.data && response.data.data) {
        this.rows = response.data.data;
        this.totalRows = response.data.meta.total;
      }
    },
    handlePageChanged(params) {
      this.getCampaigns({page: params.currentPage});
    },
  },
  watch: {
    audience: {
      handler: function(value) {
        this.getCampaigns();
      },
    },
  },
  computed: {
    columns() {
      return [
        {
          label: 'Campaign Title',
          field: 'displayName',
        },
        {
          label: 'Type',
          field: 'type',
        },
        {
          label: 'Booked At',
          field: 'createdAt',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
        }
      ];
    },
    paginationOptions() {
      return {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        setCurrentPage: this.currentPage,
        perPage: 15
      };
    },
  },
  mounted() {
    this.registerApis(['GET-CAMPAIGNS']);
  },
};
</script>
